'use client';

import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { mapaStore } from '@/infrastructure/store/mapaStore';

export function useMapa() {
  return useStore(
    mapaStore,
    useShallow((s) => ({
      mapa: s.mapa,
      loading: s.loading,
      failed: s.failed,
      grade: s.grade,
      gradeLoading: s.gradeLoading,
      gradeFailed: s.gradeFailed,
      gradeDaFabrica: s.gradeDaFabrica,
      gradeDaFabricaLoading: s.gradeDaFabricaLoading,
      gradeDaFabricaFailed: s.gradeDaFabricaFailed,
      marcasDaFabrica: s.marcasDaFabrica,
      marcasDaFabricaLoading: s.marcasDaFabricaLoading,
      marcasDaFabricaFailed: s.marcasDaFabricaFailed,
      marca: s.marca,
      cliente: s.cliente,
      celula: s.celula,
      horizonte: s.horizonte,
      vendoProposta: s.vendoProposta,
      mapaDaProposta: s.mapaDaProposta,
      mapaDaPropostaLoading: s.mapaDaPropostaLoading,
      mapaDaPropostaFailed: s.mapaDaPropostaFailed,
      gradeDaProposta: s.gradeDaProposta,
      gradeDaPropostaLoading: s.gradeDaPropostaLoading,
      gradeDaPropostaFailed: s.gradeDaPropostaFailed,
      simulacao: s.simulacao,
      simulando: s.simulando,
      aplicando: s.aplicando,
      simulacaoError: s.simulacaoError,
      ficha: s.ficha,
      fichaLoading: s.fichaLoading,
      fichaError: s.fichaError,
      loadMapa: s.loadMapa,
      loadGrade: s.loadGrade,
      loadGradeDaFabrica: s.loadGradeDaFabrica,
      loadMarcasDaFabrica: s.loadMarcasDaFabrica,
      setMarca: s.setMarca,
      setCliente: s.setCliente,
      setCelula: s.setCelula,
      setHorizonte: s.setHorizonte,
      verProposta: s.verProposta,
      verAtual: s.verAtual,
      simular: s.simular,
      aplicar: s.aplicar,
      clearSimulacao: s.clearSimulacao,
      openFicha: s.openFicha,
      closeFicha: s.closeFicha,
    })),
  );
}
